export default __webpack_public_path__ + "static/media/white.0bca6832.jpg";